/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_ToolsInputs */

const cs_property_list_tools = /** @type {(inputs: Property_List_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nástroje nemovitosti`)
};

const en_property_list_tools = /** @type {(inputs: Property_List_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property tools`)
};

/**
* | output |
* | --- |
* | "Property tools" |
*
* @param {Property_List_ToolsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_tools = /** @type {((inputs?: Property_List_ToolsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_ToolsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_tools(inputs)
	return cs_property_list_tools(inputs)
});